import { API_BASE } from "./api";

/** Ensure a stable anonymous session id (also used by cart for guest state). */
function ensureSessionId() {
  try {
    let sid = localStorage.getItem("mercago_session_id");
    if (!sid) {
      sid =
        "s-" +
        Math.random().toString(36).slice(2) +
        Date.now().toString(36);
      localStorage.setItem("mercago_session_id", sid);
    }
    return sid;
  } catch {
    return undefined;
  }
}

/**
 * Fire-and-forget beacon reporting a WhatsApp CTA click. Never blocks the
 * user's navigation. Prefers navigator.sendBeacon (survives page unload).
 */
export function reportWhatsAppClick(source, extra = {}) {
  try {
    const payload = JSON.stringify({
      source,
      session_id: ensureSessionId(),
      ...extra,
    });
    const url = `${API_BASE}/whatsapp-click`;
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    } else if (typeof fetch !== "undefined") {
      fetch(url, {
        method: "POST",
        body: payload,
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* fire-and-forget: never throw */
  }
}
